/* action type */
export const UPDATE_DATA_OBJECT = 'UPDATE_DATA_OBJECT';

/* action creator */
export const updateDataObjectAction = (actionPayload: any) => {
  return {
    type: UPDATE_DATA_OBJECT,
    payload: actionPayload
  };
};
